import React, { useEffect, useMemo, useRef, useState } from 'react';

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 ._-/';

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const pad = (text, width) => {
  const s = String(text ?? '').toUpperCase();
  if (s.length >= width) return s.slice(0, width);
  return s.padEnd(width, ' ');
};

const FlapCell = ({ target, delayMs, durationMs, reduced }) => {
  const [char, setChar] = useState(target);
  const prev = useRef(target);

  useEffect(() => {
    if (prev.current === target) return;
    prev.current = target;
    if (reduced) {
      setChar(target);
      return;
    }
    const steps = 4;
    let timeouts = [];
    for (let i = 1; i <= steps; i++) {
      timeouts.push(
        setTimeout(() => {
          if (i < steps) {
            setChar(ALPHABET[Math.floor(Math.random() * ALPHABET.length)]);
          } else {
            setChar(target);
          }
        }, delayMs + (i * durationMs) / steps)
      );
    }
    return () => timeouts.forEach(clearTimeout);
  }, [target, delayMs, durationMs, reduced]);

  return (
    <span
      style={{
        display: 'inline-block',
        width: '0.7em',
        textAlign: 'center',
        transform: 'rotateX(0deg)',
        transition: `transform ${durationMs / 4}ms ease-out`,
      }}
    >
      {char}
    </span>
  );
};

const SplitFlap = ({ text, width = 8, durationMs = 350, className = '' }) => {
  const reduced = useMemo(prefersReducedMotion, []);
  const chars = pad(text, width).split('');
  return (
    <span className={className} style={{ letterSpacing: '0.05em' }}>
      {chars.map((c, i) => (
        <FlapCell key={i} target={c} delayMs={i * 40} durationMs={durationMs} reduced={reduced} />
      ))}
    </span>
  );
};

export default SplitFlap;
